import React, { Component } from 'react'
import i18n from 'i18next'
import * as R from 'ramda'

import Input from '../form/Input'
import Button from '../../UniformComponents/Button'

class Standard extends Component {
    constructor(props) {
        super(props)
        const { certificationStore } = props
        const { manualResponseRate } = certificationStore
        this.state = {
            editing: manualResponseRate === undefined,
        }
    }

    sentThroughExploriLabel = (rules = []) => {
        const rulesArr = Object.keys(rules).filter((k) => rules[k])

        if (['email'].every((r) => rulesArr.includes(r) && rulesArr.length === 1)) {
            return i18n.t('certification.ui.standard.E')
        }
        if (['email', 'onSite'].every((r) => rulesArr.includes(r)) && rulesArr.length === 2) {
            return i18n.t('certification.ui.standard.EO')
        }
        if (['email', 'onSite', 'campaign'].every((r) => rulesArr.includes(r)) && rulesArr.length === 3) {
            return i18n.t('certification.ui.standard.EOC')
        }
        if (['onSite'].every((r) => rulesArr.includes(r)) && rulesArr.length === 1) {
            return i18n.t('certification.ui.standard.O')
        }
        if (['onSite', 'campaign'].every((r) => rulesArr.includes(r)) && rulesArr.length === 2) {
            return i18n.t('certification.ui.standard.OC')
        }
        if (['campaign'].every((r) => rulesArr.includes(r)) && rulesArr.length === 1) {
            return i18n.t('certification.ui.standard.C')
        }

        return i18n.t('certification.ui.standard.sentTroughExplori')
    }

    standardType = (standard) => {
        const { type, rules } = standard

        const label = type === 'sentTroughExplori'
            ? this.sentThroughExploriLabel(rules)
            : i18n.t(`certification.ui.standard.${standard.type}`, standard)

        return (
            <label>
                {label}
            </label>
        )
    }

    setCampaignRate = ({ value }) => {
        const { certificationStore, index } = this.props
        const rate = R.isEmpty(value) ? Number.NaN : Number(value)
        certificationStore.setResponseRate(rate, index)
    }

    responseRateCampaign = ({ otherSampleSize, passed, surveyCompletions }) => {
        const { editing } = this.state
        const { certificationStore } = this.props
        const { updateSurveyCertification, manualResponseRate } = certificationStore
        const editingLabel = !editing ? i18n.t('certification.ui.standard.passedResponseCount', { otherSampleSize, manualResponseRate }) : i18n.t('certification.ui.standard.editingResponseCount', { otherSampleSize })
        const failedLabel = surveyCompletions > 0
            ? editingLabel
            : i18n.t('certification.ui.standard.responseRateEmail')
        const editingControls = surveyCompletions > 0 ? (
            <>
                <Input
                    onBlur={this.setCampaignRate}
                    cssClass="responseInput"
                    defaultValue={manualResponseRate}
                />
                <Button
                    label="Confirm"
                    onClick={() => {
                        updateSurveyCertification()
                        this.setState({ editing: false })
                    }}
                />
            </>
        ) : null

        return (
            <div className="campaignResponseRate" style={{ display: !editing ? 'flex' : 'block' }}>
                <label>
                    {passed
                        ? i18n.t('certification.ui.standard.passedResponseCount', { otherSampleSize, manualResponseRate })
                        : failedLabel}
                </label>
                <div className={`controls ${editing ? 'has-content' : ''}`}>
                    {!editing ? (
                        <i
                            className="fa-regular fa-pen-to-square"
                            label="Edit"
                            onClick={() => {
                                this.setState({ editing: true })
                            }}
                        />
                    )
                        : editingControls}
                </div>
            </div>
        )
    }

    renderType = (standard) => {
        switch (standard.type) {
            case 'responseRateCampaign':
                return this.responseRateCampaign(standard)
            default:
                return this.standardType(standard)
        }
    }

    render() {
        const { standard, icon } = this.props
        const { passed } = standard

        const currentIcon = passed
            ? 'fa-light fa-seal pass'
            : 'fal fa-times-circle'

        return (
            <div className="standard">
                <div
                    style={{
                        position: 'relative',
                        display: 'flex',
                    }}
                >
                    <i className={icon || currentIcon} />
                </div>
                {this.renderType(standard)}
            </div>
        )
    }
}

export default Standard
